import type * as React from 'react';

export function AppSearchGroupHeader(props: {
    suffix?: string;
    title?: string;
    icon?: React.ReactNode;
}) {
    const { suffix, title, icon } = props;
    return (
        <div className="flex items-center gap-1.5 pt-2 text-ui-small text-neutral-low">
            {title ? <span className="font-medium text-neutral-high">{title}</span> : null}
            {icon || suffix ? (
                <div className="flex items-center gap-1">
                    {icon}
                    {suffix ? <span>{suffix}</span> : null}
                </div>
            ) : null}
        </div>
    );
}
